import React from "react"
import {H2, Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"

interface Props {}

const StockAssignmentError: React.FC<Props> = () => {
  return (
    <>
      <H2 marginBottom>
        <FormattedMessage id="platform.oops.header.text" />
      </H2>
      <Body marginBottom={2}>
        <FormattedMessage id="perks.components.stockAssignmentError.errorText" />
      </Body>
    </>
  )
}

export default StockAssignmentError
